export const ColumnIds = {
  name: 'name',
  displayOrder: 'displayOrder',
} as const;
